import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.white,
      userSelect: 'none'
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: '40px',
      flexWrap: 'wrap',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        alignItems: 'start',
        gap: '30px'
      }
    },
    footer: {
      position: 'absolute',
      bottom: '10px',
      right: '0',
      left: '0',
      display: 'flex',
      justifyContent: 'center',
      '@media (max-width: 768px)': {
        position: 'static',
        marginTop: '50px'
      }
    },
    littleText: {
      fontSize: '0.875rem',
      fontWeight: 'bold'
    },
    help: {
      fontSize: '0.875rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      '@media (max-width: 768px)': {
        paddingLeft: '20px'
      }
    },
    title: {
      fontSize: '2.5rem',
      margin: '0',
      '@media (max-width: 768px)': {
        fontSize: '1.75rem'
      }
    },
    space: {
      marginBottom: '5px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
